export interface Fact {
  term: string;
  value: string;
}

/**
 * A term-and-value table: where a studio is based, what a project runs on, who
 * a legal entity is. Sits on tinted grounds as well as white, so its text uses
 * the -on-accent tones.
 */
export function Facts({ rows }: Readonly<{ rows: Fact[] }>) {
  return (
    <dl className="facts">
      {rows.map((row) => (
        <div key={row.term}>
          <dt>{row.term}</dt>
          <dd>{row.value}</dd>
        </div>
      ))}
    </dl>
  );
}
